import { highScores } from '@/mocks/animeData';

export default function HighScores() {
  return (
    <section id="score" className="scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              高分漫画
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              口碑扎实的连载与完结佳作，评分 9.0 以上放心入坑
            </p>
          </div>
          <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
            <i className="ri-star-fill"></i>
            9.0+ 高分榜
          </span>
        </div>

        <div className="grid grid-cols-1 gap-3 md:gap-5 lg:grid-cols-2">
          {highScores.map((comic, idx) => (
            <article
              key={comic.id}
              className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300 md:p-4"
              data-product-shop
            >
              <div className="w-20 shrink-0 sm:w-28">
                <img
                  src={comic.image}
                  alt={`${comic.title} 高分漫画封面`}
                  title={`高分佳作 ${comic.title} 评分 ${comic.score}`}
                  className="aspect-[3/4] w-full rounded-md object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="truncate text-base font-bold text-foreground-950 group-hover:text-accent-700">
                    {comic.title}
                  </h3>
                  <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-sm font-bold text-accent-700">
                    <i className="ri-star-fill text-xs"></i>
                    {comic.score}
                  </span>
                </div>
                <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-600">
                  {comic.desc}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700">
                    {comic.genre}
                  </span>
                  {comic.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-600"
                    >
                      {tag}
                    </span>
                  ))}
                  <span className="ml-auto text-xs text-foreground-400">
                    {comic.status === '已完结' ? '已完结' : `更新至 ${comic.chapter}`}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}